import {isFabricWebview} from '~/common/utils/webview';

const TEST_3_ACROSS_AB_EXPERIMENT_NAME = 'test_3_across_ab';

const cardsPage = window.cards_page;

export const isIn3AcrossABTest = () =>
  !cardsPage &&
  evite.experiments.inVariation(
    TEST_3_ACROSS_AB_EXPERIMENT_NAME,
    'variant',
    false,
    isFabricWebview() || cardsPage
  );
